/** @jsx jsx */
import { jsx, Flex, Box, Styled } from "theme-ui"

import { Large } from "components/type"

import Container from "../grid/container"
import Row from "../grid/row"
import Col from "../grid/col"

import Ottawa from "components/svgs/ottawa"
import Ontario from "components/svgs/ontario"

import useLocales from "hooks/use-locales"

const Footer = () => {
  const { t } = useLocales()
  return (
    <footer sx={{ pt: 5 }}>
      <Container>
        <Flex
          sx={{
            alignItems: "center",
            justifyContent: "center",
            flexDirection: ["column", "row"],
          }}
        >
          <Ottawa sx={{ mx: [0, 3] }} />
          <Ontario sx={{ mx: [0, 3] }} />
        </Flex>
      </Container>
      <Box sx={{ bg: "primary", color: "background", pt: 5, pb: 3 }}>
        <Container>
          <Row sx={{ flexWrap: "wrap" }}>
            <Col sx={{ width: ["100%", "33.333%"] }}>
              <Large sx={{ fontWeight: 600, my: 0 }}>
                {t("headOffice.title")}
              </Large>
              <Styled.p>
                {t("headOffice.address.one")}
                <br />
                {t("headOffice.address.two")}
              </Styled.p>
            </Col>
            <Col sx={{ width: ["100%", "33.333%"] }}>
              <Large sx={{ fontWeight: 600, my: 0 }}>{t("phone.title")}</Large>
              <Styled.p>
                {t("phone.number")}
                <br />
                {t("phone.fax")}
                <br />
                {t("phone.tty")}
              </Styled.p>
            </Col>
            <Col sx={{ width: ["100%", "33.333%"] }}>
              <Large sx={{ fontWeight: 600, my: 0 }}>
                {t("contact.title")}
              </Large>
              <Styled.p>
                {t("contact.email")}{" "}
                <a href="mailto:info@eorc-creo.ca" sx={{ color: "background" }}>
                  info@eorc-creo.ca
                </a>
                <br />
                {t("contact.facebook")}{" "}
                <a
                  href="https://www.facebook.com/EORCCREO/"
                  sx={{ color: "background" }}
                >
                  /EORCCREO
                </a>
                <br />
                {t("contact.twitter")}{" "}
                <a
                  href="https://twitter.com/EORCOttawa"
                  sx={{ color: "background" }}
                >
                  @EORCOttawa
                </a>
              </Styled.p>
            </Col>
          </Row>
          <Styled.p>
            &copy;2020, {t("org")}. Website by{" "}
            <a
              sx={{
                color: "background",
                fontWeight: "bold",
                "&:hover": { textDecoration: "none" },
              }}
              href="https://floating-point.com"
            >
              floating-point
            </a>
            .
          </Styled.p>
        </Container>
      </Box>
    </footer>
  )
}

export default Footer
